export default "/images/b3121c23060096673573cae79a799e6d.avif";